import React from 'react';
import { Field } from '../../../../common';
import './IdField.scss';

const IdField = ({ heading, ...rest }) => {
  return <div className="registration-id-field">
    <div className="registration-id-field-heading">{heading}</div>
    <Field {...rest} />
  </div>
}

export default IdField